import { render, staticRenderFns } from "./CustomersAcquisitionChannelsStatistics.vue?vue&type=template&id=1032b800"
import script from "./CustomersAcquisitionChannelsStatistics.vue?vue&type=script&lang=ts"
export * from "./CustomersAcquisitionChannelsStatistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports